import { z } from 'zod';

import { requiredString } from '@/utils/zodUtils';

export const TermSelectorSchema = (t) =>
  z
    .object({
      term: requiredString(t),
    })
    .strict();
